import http from '~/utils/http'

/** 教材（对应后端 GetTextbookRes 的子集）。 */
export interface CourseTextbook {
  id: number
  title: string | null
  level: number
}

/** 学生当前课程进度（后端 CourseProgressRes 的子集）。 */
export interface CurrentCourseProgress {
  textbook: CourseTextbook | null
  preChapter: CourseTextbook | null
  progress: number
}

/**
 * 管理员调整学生的教材进度。
 * textbookId 必须是三级教材（章节）。进度只能前进、不能回退（后端约束）。
 */
export function adjustStudentCourseProgress(data: {
  studentId: number
  textbookId: number
}) {
  return http.post('/admin/course/progress/adjust', data)
}

/** 管理员查询学生当前课程进度（无进度时后端返回 null）。 */
export function getStudentCurrentCourseProgress(studentId: number) {
  return http.get<CurrentCourseProgress | null>(
    `/admin/course/progress/current/${studentId}`,
  )
}
